import { InputDeviceType, ControllerHand, degToRad } from "flavr-common";
import { Vector3, Quaternion } from "flavr-math";
import { SELECTION_STRATEGY } from "../../../messages/selection";
export const HTC_VIVE_CONTROLLER_MESH_INFO = {
    name: "htc",
    type: InputDeviceType.HtcViveController,
    file: "meshes/htc/htc_controller_with_buttons",
    side: ControllerHand.Unknown,
    buttons: [
        {
            index: 0,
            annotation: {
                anchorPoint: [0, -0.02805, 0.04527],
                position: [0.06, -0.02805, 0.04527]
            },
            subMeshNames: {
                pressed: "button_trigger_1",
                released: "button_trigger_0"
            }
        },
        {
            index: 1,
            subMeshNames: {
                pressed: "button_grip_right_1",
                released: "button_grip_right_0"
            }
        },
        {
            index: 1,
            annotation: {
                anchorPoint: [-0.01976, -0.01532, 0.08361],
                position: [-0.04, -0.02, 0.084]
            },
            subMeshNames: {
                pressed: "button_grip_left_1",
                released: "button_grip_left_0"
            }
        },
        {
            index: 2,
            annotation: {
                anchorPoint: [-0.02077, 0.00379, 0.04566],
                position: [-0.06, 0.005, 0.045]
            },
            subMeshNames: {
                pressed: "trackpad_1",
                released: "trackpad_0"
            }
        },
        {
            index: 4,
            annotation: {
                anchorPoint: [-0.00451, 0.00763, 0.01635],
                position: [-0.04, 0.03, 0.0]
            },
            subMeshNames: {
                pressed: "button_menu_1",
                released: "button_menu_0"
            }
        }
    ],
    invertYAxis: 1,
    recordIndicator: {
        position: new Vector3(0, 0.0055, 0.044762),
        orientation: new Quaternion().setFromAxisAngle(new Vector3(1, 0, 0), degToRad(6.53054 - 90)),
        scale: new Vector3().setScalar(0.045)
    },
    makerRadar: {
        radius: 0.05,
        position: new Vector3(0, -0.003346, -0.063921),
        markerScale: 0.04
    },
    gripSpace: {
        position: new Vector3(),
        orientation: new Quaternion(),
        scale: new Vector3(1, 1, 1)
    },
    selection: {
        strategy: SELECTION_STRATEGY.RAY_SELECT,
        params: {
            max_ray_length: 1000,
            ray_visible: true,
            ray_color: 0x06316d
        }
    }
};
